module.exports = __webpack_public_path__ + "media/images/top/top-og-image-827a08a456628709b1f65813e8c14bcc.png";